<template>
  <div>
    <b-form @submit.prevent="onSubmit" class="m-6">
      <b-form-row>
        <b-col cols="12" md="6">
          <b-form-group
            class="form-group"             
            label-size="sm"
            label-color="#a6bbc3"
            label="Voornaam"
            >
            <b-form-input
              v-model.lazy.trim="$v.firstName.$model"
              placeholder="Voornaam"
              :state="$v.firstName.$dirty ? !$v.firstName.$invalid : null"
            >           
            </b-form-input>
            <b-form-invalid-feedback>
              <div v-if="$v.firstName.$invalid">
                {{ 'Vul a.u.b. uw voornaam in' }}
              </div>
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>

        <b-col cols="12" md="6">
          <b-form-group 
            class="form-group"             
            label-size="sm"
            label-color="#a6bbc3"
            label="Achternaam"
            >
            <b-form-input
              v-model.lazy.trim="$v.lastName.$model"
              placeholder="Achternaam"
              :state="$v.lastName.$dirty ? !$v.lastName.$invalid : null"
            >           
            </b-form-input>
            <b-form-invalid-feedback>
              <div v-if="$v.lastName.$invalid">
                {{ 'Vul a.u.b. uw achternaam in' }}
              </div>
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-form-row>
      
      <b-form-row>
        <b-col>
          <b-form-group
            class="form-group"            
            label-size="sm"
            label-color="#a6bbc3"
            label="E-mailadres">
            <b-form-input
              v-model.lazy.trim="$v.email.$model"
              placeholder="E-mailadres"
              :state="$v.email.$dirty ? !$v.email.$invalid : null"
            >           
            </b-form-input>
            <b-form-invalid-feedback>
              <div v-if="$v.email.$invalid">
                {{ 'Vul a.u.b. een E-mailadres in' }}
              </div>
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-form-row>

      <b-form-row>
        <b-col>
          <b-form-group
            class="form-group"             
            label-size="sm"
            label-color="#a6bbc3"
            label="E-mailadres controle">
            <b-form-input
              v-model.lazy.trim="$v.emailVerification.$model"
              placeholder="E-mailadres controle"
              :state="$v.emailVerification.$dirty ? !$v.emailVerification.$invalid : null"
            >           
            </b-form-input>
            <b-form-invalid-feedback>
              <div v-if="$v.emailVerification.$invalid">
                {{ 'Het E-mailadres komt niet overeen' }}
              </div>
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-form-row>

      <b-form-row>
        <b-col>
          <b-form-group
            class="form-group"             
            label-size="sm"
            label-color="#a6bbc3"
            label="Straat en huisnummer"
            >
            <b-form-input
              v-model.lazy.trim="$v.street.$model"
              placeholder="Straat en huisnummer"
              disabled
              :state="$v.street.$dirty ? !$v.street.$invalid : null"
            >           
            </b-form-input>
            <b-form-invalid-feedback>
              <div v-if="$v.street.$invalid">
                {{ 'Vul a.u.b. een straat en huisnummer in' }}
              </div>
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-form-row>

      <b-form-row lg="6">
        <b-col cols="12" md="6">
          <b-form-group
            class="form-group"              
            label-size="sm"
            label-color="#a6bbc3"
            label="Postcode"
          >
            <b-form-input
              v-model.lazy.trim="$v.postalCode.$model"
              placeholder="Postcode"
              disabled
              :state="$v.postalCode.$dirty ? !$v.postalCode.$invalid : null"
            >           
            </b-form-input>
            <b-form-invalid-feedback>
              <div v-if="$v.postalCode.$invalid">
                {{ 'Vul a.u.b. een geldige postcode in' }}
              </div>
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-group
            class="form-group"             
            label-size="sm"
            label-color="#a6bbc3"
            label="Telefoonnummer"
          >
            <b-form-input
              v-model.lazy.trim="$v.telephone.$model"
              placeholder="Telefoonnummer"
              :state="$v.telephone.$dirty ? !$v.telephone.$invalid : null"
            >           
            </b-form-input>
            <b-form-invalid-feedback>
              <div v-if="$v.telephone.$invalid">
                {{ 'Vul a.u.b. een geldig telefoonnummer in' }}
              </div>
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-form-row>

      <b-form-row>
        <b-col>
          <b-form-group
            class="form-group"             
            label-size="sm"
            label-color="#a6bbc3"
            label="Plaats">
            <b-form-input
              v-model.lazy.trim="$v.city.$model"
              disabled
              placeholder="Plaats"
              :state="$v.city.$dirty ? !$v.city.$invalid : null"
            >           
            </b-form-input>
            <b-form-invalid-feedback>
              <div v-if="$v.city.$invalid">
                {{ 'Vul a.u.b. een plaats in' }}
              </div>
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-form-row>

      <div class="mt-6">
        <b-form-group class="b2b-acceptance-checkboxes">
          <b-form-checkbox
            class="mb-2"
            v-model="checkBoxAutoPaymentsAndAmountOfPanels"
            :value="true"
            :unchecked-value="false"
            :state="$v.checkBoxAutoPaymentsAndAmountOfPanels.$dirty ? !$v.checkBoxAutoPaymentsAndAmountOfPanels.$invalid : null"
            name="checkBoxAutoPayments">
            <span class="pt-1 font-size-sm">
              {{ `Ja, ik kies voor ${selectedQuote.numberOfPanels} panelen met een jaarlijkse stroomproductie van ${$options.filters.formatKwh(selectedQuote.energyGenerated)} tegen een bijdrage van ${$options.filters.formatCurrency(selectedQuote.monthlyPayment)} per maand` }}
            </span>
          </b-form-checkbox>
          <b-form-checkbox
            class="mb-2"
            v-model="checkBoxTermsAndConditions"
            :value="true"
            :unchecked-value="false"
            :state="$v.checkBoxTermsAndConditions.$dirty ? !$v.checkBoxTermsAndConditions.$invalid : null"
            name="checkBoxTermsAndConditions">
            <span class="pt-1 font-size-sm">
              Ja, ik ga akkoord met de&nbsp; <a :href="termsAndConditionsUrl" target="_blank">Algemene Voorwaarden</a>
            </span>
          </b-form-checkbox>
          <b-form-checkbox
            v-model="checkBoxAddressConfirmation"
            :value="true"
            :unchecked-value="false"
            :state="$v.checkBoxAddressConfirmation.$dirty ? !$v.checkBoxAddressConfirmation.$invalid : null"
            name="checkBoxAddressConfirmation">
            <span class="pt-1 font-size-sm">
              Ja, ik ben de bewoner van dit adres en/of bevoegd om dit aanbod te accepteren
            </span>
          </b-form-checkbox>
        </b-form-group>
      </div>
      <b-row class="mt-6">
        <b-col cols="12" lg="4">
          <span v-if="error"> Sorry, er gaat iets mis. Probeer het later opnieuw of neem contact met ons op. </span>
          <b-button 
            class="btn-block text-align justify-content-center"
            type="submit" 
            variant="primary" 
            :disabled="pending">
            <span
              class="spinner-border spinner-border-sm mr-2"
              role="status"
              aria-hidden="true"
              v-if="pending"
            ></span>
            <span>ACCEPTEER HET AANBOD</span>
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import { required, email as emailValidation, sameAs } from 'vuelidate/lib/validators'
import { mapGetters } from 'vuex'
import { validPostalCodeNetherlands, validTelephone, boxIsChecked } from '@/components/b2b/validationHelpers.js'

export default {
  name: 'B2bOfferForm',
  props: {
    selectedQuote: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters(['iquote', 'company']),
    termsAndConditionsUrl() {
      // TODO: We should filter on general terms and conditions type here 
      // but so far everything in odoo has type sunsure.
      return this.selectedQuote.termsAndConditions && this.selectedQuote.termsAndConditions[0].pdfUrl
    }
  },
  data() {
    return {
      firstName: '',
      lastName: '',
      email: '',
      emailVerification: '',
      street: '',
      postalCode: '',
      telephone: '',
      city: '',
      checkBoxTermsAndConditions: false,
      checkBoxAddressConfirmation: false,
      checkBoxAutoPaymentsAndAmountOfPanels: false,
      pending: false,
      error: false,
    }
  },
  validations() {
    return {
      firstName: {
        required,
      },
      lastName: {
        required,
      },
      email: {
        emailValidation,
        required,
      },
      emailVerification: {
        sameAs: sameAs(function() { return this.email }),
        required,
      },
      street: {
        required
      },
      postalCode: {
        required,
        validPostalCodeNetherlands
      },
      telephone: {
        required,
        validTelephone
      },
      city: {
        required
      },
      checkBoxTermsAndConditions: {
        boxIsChecked
      },
      checkBoxAddressConfirmation: {
        boxIsChecked
      },
      checkBoxAutoPaymentsAndAmountOfPanels: {
        boxIsChecked
      },
    }
  },
  methods: {
    async onSubmit() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }
      this.error = false
      this.pending = true


      // get external preview mode from store
      const externalQuery = this.$store.getters.externalQuery
      if (externalQuery && externalQuery.preview) {
        alert('You cannot pay/confirm an order in preview mode.')
        return null
      }

      const payload = {
        firstName: this.firstName,
        lastName: this.lastName,
        email: this.email,
        street: this.street,
        postalCode: this.postalCode,
        phone: this.telephone,
        city: this.city,
        chosenQuoteId: this.selectedQuote.id,
      }

      const res = await this.$store.dispatch('confirmOrder', payload)

      if (res === 'OK') await this.checkOrderConfirmationStatus()
      else {
        this.error = true
        this.pending = false
      }

    },
    async checkOrderConfirmationStatus(wait = 0) {
      await this.$store.dispatch('getIquote', 'b2b')
      if (this.iquote.orderPlaced) {
        this.$router.push({ name: 'B2bConfirmation' })
      } else if (wait < 7000) {
        setTimeout(() => this.checkOrderConfirmationStatus(wait + 1000), wait)
      } else { 
        this.error = true
        this.pending = false
      }
    }
  },
  mounted() {
    const { street, houseNumber, houseNumberAddition, postalCode, city } = this.contact.address

    this.firstName = this.contact.firstName
    this.lastName = this.contact.lastName
    this.street = `${street} ${houseNumber} ${houseNumberAddition ? `${houseNumberAddition}` : '' }`
    this.postalCode = postalCode
    this.city = city
  }
}
</script>
